var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIconV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9992 18.8234L14.7921 13.6163C17.7037 10.0554 17.1773 4.80834 13.6163 1.89678C10.0554 -1.01479 4.80834 -0.488381 1.89678 3.07256C-1.01479 6.63349 -0.488381 11.8806 3.07256 14.7921C6.13978 17.3 10.5492 17.3 13.6163 14.7921L18.8234 19.9992L19.9992 18.8234ZM8.35775 15.01C4.68381 15.01 1.70553 12.0317 1.70553 8.35775C1.70553 4.68385 4.68381 1.70553 8.35775 1.70553C12.0317 1.70553 15.01 4.68385 15.01 8.35775C15.0059 12.03 12.03 15.0059 8.35775 15.01Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconV2);
export default __webpack_public_path__ + "static/media/searchIconV2.23b041d48677897ca2bf3274f3c82524.svg";
export { ForwardRef as ReactComponent };